import { render, staticRenderFns } from "./FundValuePerformanceChart.vue?vue&type=template&id=4e9e1fc8&"
import script from "./FundValuePerformanceChart.vue?vue&type=script&lang=ts&"
export * from "./FundValuePerformanceChart.vue?vue&type=script&lang=ts&"
import style0 from "./FundValuePerformanceChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports